module.exports = __webpack_public_path__ + "static/media/GT02_AT_Accommodation-Types.077d41e5.csv";